import { createContext, useContext, useEffect, useState } from "react";
import { filterByName } from "./util";
import { useFilter } from "./filter";
import { useRest, useRestCall } from "./rest";

const SearchContext = createContext();
export function Search(props) {
    const { req } = props;

    const filter = useFilter()
    const [selected, setSelected] = useState()
    const [result, reload] = useRest(req)

    useEffect(() => {
        if (!filter.active) {
            setSelected(undefined)
        }
    }, [filter.active])

    return <SearchContext.Provider
        {...props}
        value={{
            result: result || [],
            loading: !result,
            selected,
            setSelected
        }}
    />
}

export function useSearch() {
    const { result, loading, setSelected, selected } = useContext(SearchContext)
    const filter = useFilter()

    const filtered = result.filter(filter.filterByName)

    return {
        result: filtered,
        loading,
        selected,
        setSelected,
    }
}